/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Insert_Field_PlaceholderInputs */

const cs_builder_insert_field_placeholder = /** @type {(inputs: Builder_Insert_Field_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte pole…`)
};

const en_builder_insert_field_placeholder = /** @type {(inputs: Builder_Insert_Field_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a field…`)
};

/**
* | output |
* | --- |
* | "Choose a field…" |
*
* @param {Builder_Insert_Field_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_insert_field_placeholder = /** @type {((inputs?: Builder_Insert_Field_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Insert_Field_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_insert_field_placeholder(inputs)
	return cs_builder_insert_field_placeholder(inputs)
});